import textFit from 'textFit';

const campaignJsButton = {};

campaignJsButton.init = () => {
  let fontSize = 27;
  if (window.innerWidth < 1440) {
    fontSize = 19;
  }

  textFit(document.getElementsByClassName('js-campaign-button'), {
    maxFontSize: fontSize,
    multiLine: true,
	detectMultiLine: true,
	alignVertWithFlexbox: true
  });
};


document.addEventListener('DOMContentLoaded', () => {
  campaignJsButton.init();
});



// WEBPACK FOOTER //
// ./scripts/components/campaign-button.js